export const listingsConstants = {
  DEFAULT_API_TAKE: 10,
  MAX_RESULTS: 500,
};
